import { IButtonProps, ITooltipHostProps, IconButton as FabricIconButton } from "@fluentui/react";
import React from "react";

import { TooltipHost } from "../../surfaces/tooltip/TooltipHost";

interface IconButtonProps
    extends Pick<IButtonProps, "id" | "iconProps" | "onClick" | "disabled" | "menuProps" | "menuIconProps"> {
    tooltipContent?: string;
    testId?: string;
    styles?: {
        tooltipHost?: ITooltipHostProps["styles"];
        iconButton?: IButtonProps["styles"];
    };
}

export const IconButton: React.FC<IconButtonProps> = ({
    id,
    iconProps,
    disabled,
    tooltipContent,
    menuProps,
    menuIconProps,
    testId,
    styles,
    onClick
}: IconButtonProps) => {
    return (
        <TooltipHost content={tooltipContent} styles={{ root: { display: "inline-block" }, ...styles?.tooltipHost }}>
            <FabricIconButton
                key={id}
                iconProps={iconProps}
                onClick={onClick}
                disabled={disabled}
                menuProps={menuProps}
                menuIconProps={menuIconProps}
                styles={{ ...styles?.iconButton }}
                data-testId={testId}
            />
        </TooltipHost>
    );
};
